"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { House, Leaf, Timer } from "lucide-react";

const NAVIGATION_LINKS = [
  { href: "/home", label: "Home", icon: House },
  { href: "/exercise-timer", label: "Exercise timer", icon: Timer },
];

export function Navbar() {
  const pathname = usePathname();
  return (
    <header className="site-header">
      <div className="nav-inner">
        <Link href="/home" className="brand">
          <span className="brand-icon">
            <Leaf size={22} />
          </span>
          everyday<span className="brand-dot">.</span>
        </Link>
        <nav aria-label="Main navigation">
          {NAVIGATION_LINKS.map(({ href, label, icon: Icon }) => {
            const active =
              pathname === href || (href === "/home" && pathname === "/");
            return (
              <Link
                key={href}
                href={href}
                className={`nav-link ${active ? "active" : ""}`}
                aria-current={active ? "page" : undefined}
              >
                <Icon size={17} />
                {label}
              </Link>
            );
          })}
        </nav>
        <span className="nav-caption">A little more balance.</span>
      </div>
    </header>
  );
}
